<template>
	<div id="container" v-bind:class="content[which].columnC ? 'cols-3': 'cols-2'">
		<div id="columns" v-bind:class="content[which].classes">
			<div id="col-a" class="col" v-if="content[which].columnA">
				<img v-if="content[which].columnChide === false && content[which].columnAalt" v-bind:width="content[which].columnAalt" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_a_alt.png`)" />
				<img v-else v-bind:width="content[which].columnA" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_a.png`)" v-bind:class="content[which].columnAclass ? content[which].columnAclass : ''" />

				<div v-if="content[which].columnAbutton" class="col-button" v-bind:class="content[which].columnAstyle ? content[which].columnAstyle: ''">
					<div v-on:click="openOverlay([content[which].columnButtonAction,true])" class="link">
						<img v-bind:class="questionPopupDisplay ? 'question-present': ''" v-bind:width="content[which].columnAbutton" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_a_button.png`)" />
					</div>
				</div>
			</div>
			<div id="col-b" class="col" v-if="content[which].columnB">

				<img v-if="content[which].columnChide === false && content[which].columnBalt"   v-bind:width="content[which].columnBalt" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_b_alt.png`)" />
				<img v-else v-bind:width="content[which].columnB" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_b.png`)" />

				<div v-if="content[which].columnBbutton" class="col-button" v-bind:class="content[which].columnBstyle ? content[which].columnBstyle: ''">
					<div v-on:click="openOverlay([content[which].columnButtonAction,true])" class="link">
						<img v-bind:class="questionPopupDisplay ? 'question-present': ''" v-bind:width="content[which].columnBbutton" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_b_button.png`)" />
					</div>
				</div>
			</div>
			<div id=col-c class="col" v-bind:class="content[which].columnChide ? 'col-hide': ''" v-if="content[which].columnC">
				<img v-bind:width="content[which].columnC" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_c.png`)" />
				<div v-if="content[which].columnCbutton" class="col-button" v-bind:class="content[which].columnCstyle ? content[which].columnCstyle: ''">
					<div v-on:click="openOverlay([content[which].columnButtonAction,true])" class="link">
						<img v-bind:class="questionPopupDisplay ? 'question-present': ''" v-bind:width="content[which].columnCbutton" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_c_button.png`)" />
					</div>
				</div>
			</div>
		</div>
		<div id="footnote" v-if="content[which].footnote">
			<img v-bind:width="content[which].footnote" v-bind:src="require(`@/assets/patients/${which}/${tabType}/${tabType}_footnote.png`)" />
		</div>
	</div>
</template>
<script>
export default {
	props: {
		which: {
			type: String
		},
		tabType: {
			type: String
		},
		content: {
			type: Object
		},
		questionPopupDisplay: {
			type: Boolean
		}
	},
	methods: {
		openOverlay(whichActions){
			this.$emit('show-overlay',whichActions)
		}
	}
}
</script>
<style scoped>
#columns {
	display: flex;
	justify-content: space-between;
}

.col {
	position: relative;
}

.col-button {
	position: absolute;
}

.col-hide img {
	visibility: hidden;
}

#col-a .col-button {
	bottom: -5px;
	right: 0;
}

	.diagnosis #col-a .col-button {
		right: -5px;
	}
	.cycle #col-a .col-button {
		bottom: 0;
		transform: translateY(calc( 100% + 3px));
	}

#col-a .col-button.button-standalone {
	bottom: auto;
	margin-top: 10px;
	position: relative;
}

.cycle-gordon #col-a .col-button {
	right: auto;
	transform: translateY(calc( 100% + 9px));
}

.button-shift {
	margin-bottom: 40px;
}

#col-b .col-button {
	right: -5px;
	bottom: -27px;
}

#col-c .col-button {
	bottom: -15px;
	right: -9px;
}

img.question-present {
	/* filter: grayscale(100%); */
	opacity: .36;
}
</style>